export const locale = {
    lang: 'en',
    data: {
        NOTIFICATION: {
            TITLES: {
                LATEST_UPDATE: 'Latest Update',
                SHOW_MORE: 'Show More',
                SHOW_LESS: 'Show Less',
            }
        }
    }
};
